export default "__VITE_ASSET__Du8zVnM9__"